// extracted by mini-css-extract-plugin
export default {"imageWrapper":"xH-z","twoColumnImage":"yH-z"};